//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchCardLockStatusRequest,
  fetchCardLockStatusSuccess,
  fetchCardLockStatusFailure,
  updateCardLockStatusRequest,
  updateCardLockStatusSuccess,
  updateCardLockStatusFailure,
} from '../reducer/cardLockSlice';
import { getCardLockStatus, updateCardLockStatus } from '../api'; // Assuming API paths are correct

interface CardLockRequestAction {
  type: typeof fetchCardLockStatusRequest.type;
  payload: { accountId: string; customerId: string };
}

interface CardLockUpdateAction {
  type: typeof updateCardLockStatusRequest.type;
  payload: { accountId: string; customerId: string; status: string };
}

// Fetch card lock status saga
export function* fetchCardLockStatusSaga(
  action: CardLockRequestAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId } = action.payload;
    const cardLockStatus: any = yield call(
      getCardLockStatus,
      'fetch_card_lock',
      accountId,
      customerId
    );

    // If the API response has the lock status under `data`, modify the structure accordingly.
    if (cardLockStatus) {
      yield put(fetchCardLockStatusSuccess(cardLockStatus)); // Assuming API response has a `status` field
    } else {
      throw new Error('Invalid response format from the server');
    }
  } catch (error: any) {
    yield put(
      fetchCardLockStatusFailure(
        error.message || 'Failed to fetch card lock status.'
      )
    );
  }
}

// Update card lock status saga
export function* updateCardLockStatusSaga(
  action: CardLockUpdateAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, status } = action.payload;

    // Call API to update the card lock status
    yield call(
      updateCardLockStatus,
      'update_card_lock',
      accountId,
      customerId,
      status
    );

    // After successful API call, dispatch the success action with the new status
    yield put(updateCardLockStatusSuccess(status)); // Pass the new status ("LOCK" or "UNLOCK")

    // Optionally refetch the card lock status to refresh the UI
    yield put(fetchCardLockStatusRequest({ accountId, customerId }));
  } catch (error: any) {
    yield put(
      updateCardLockStatusFailure(
        error || 'Failed to update card lock status.'
      )
    );
  }
}

// Watch sagas
export function* watchCardLockStatusSagas(): Generator<any, void, unknown> {
  yield takeLatest(fetchCardLockStatusRequest.type, fetchCardLockStatusSaga);
  yield takeLatest(updateCardLockStatusRequest.type, updateCardLockStatusSaga);
}
